module.exports = "/packs/images/svg/ireland/facilities/children_facilities~de88e8063676ffea2b67f1cc9ff80699.svg";